import request from '@/api/base'

// 门锁 重置MAC
// {
//   "newMac": "string",
//   "note": "string",
//   "roomId": "string"
// }
const lockChangeMac = params => {
  return request.post('/portal/apartment/lock/changeMac', params)
}
// 门锁 校验MAC
// {
//   "newMac": "string",
//   "note": "string",
//   "roomId": "string"
// }
const lockVerifyMac = (params = {}) => {
  return request.post('/portal/apartment/lock/verifyMac', params)
}

// 获取房间物品清单
const groupByRoomId = params => {
  return request.post('/portal/apartment/goods/groupByRoomId', params)
}
// 查询物品的清单
const getListAllGoodsName = (params = {}) => {
  return request.post('/portal/apartment/goods/listAllGoodsName', params)
}
// 新增房间物品
const groupGoodsAddBatch = (params = {}) => {
  return request.post('/portal/apartment/goods/groupGoodsAddBatch', params)
}
// 获取物品清单
const getGoodsList = (params = {}) => {
  return request.post('/portal/apartment/goods/list', params)
}
// 添加物品
const addGoods = (params = {}) => {
  return request.post('/portal/apartment/goods/add', params)
}
// 更新物品清单
const updateGoods = (params = {}) => {
  return request.post('/portal/apartment/goods/updateById', params)
}
// 删除物品清单
const deleteGoods = (params = {}) => {
  return request.post('/portal/apartment/goods/delete', params)
}
// 检查名称是否使用过
const checkNumberAndName = params => {
  return request.get('/portal/apartment/goods/checkNumberAndName', { params })
}
// 详情
const getGoodsDetail = params => {
  return request.get('/portal/apartment/goods/detail', { params })
}
// 通过id查列表
const getListByRoomId = params => {
  return request.get('/portal/apartment/goods/listByRoomId', { params })
}
// 导出物品清单
const exportGoodsList = params => {
  return request.post(
    '/portal/apartment/goods/listByRoomId/exportExcel',
    params,
    { responseType: 'blob' }
  )
}

// 获取楼栋
const getBuildingList = (params = {}) => {
  // params.mockApi = true
  return request.post('/portal/apartment/buildingList', params)
}
// 获取物品清单列表
const getGoodsItem = (params = {}) => {
  // params.mockApi = true
  return request.post('/portal/apartment/goodsItem', params)
}

// 获取物品清单列表
const getGoodsList1 = (params = {}) => {
  return request.post('/portal/estate/houseStructure/list', params)
}

// 添加物品
const addGoods1 = (params = {}) => {
  return request.post('/portal/estate/houseStructure/add', params)
}

// 删除物品清单
const deleteGoods1 = (params = {}) => {
  return request.get('/portal/estate/houseStructure/delete', { params })
}

// 更新物品清单
const updateGoods1 = (params = {}) => {
  return request.post('/portal/estate/houseStructure/update', params)
}

// 获取房间信息
const getRoomInfo = params => {
  return request.get('/portal/apartment/rental/rooms/detail', { params })
}
// 导出物品清单
const exportRoomList = params => {
  return request.post('/portal/apartment/rental/rooms/explortDate', params, {
    responseType: 'blob'
  })
}

// 获取房间信息
const getRoomBillList = (params = {}) => {
  // params.mockApi = true
  return request.post('/portal/apartment/roomBillList', params)
}

// 获取入住申请列表
const getRentalList = params => {
  return request.post('/portal/apartment/rental/rentalList', params)
}
// 入住申请列表d导出
const exportRentalList = params => {
  return request.post(
    '/portal/apartment/rental/rentalList/list/export',
    params,
    { responseType: 'blob' }
  )
}

// 公寓账单
// const getRentalList = (params) => {
//   return request.post('/portal/apartment/rental/rentalList', params)
// }
const approve = params => {
  return request.post('/portal/apartment/rental/approve', params)
}
// 获取 租户代表和 紧急联系人 详情
const getContactListOrAuthorizers = params => {
  return request.get('/portal/apartment/rental/getContactListOrAuthorizers', {
    params
  })
}
// 入住申请
const rentalAdd = params => {
  return request.post('/portal/apartment/rental/rentalAdd', params)
}
// 入住申请详情
const rentalDetail = params => {
  return request.get('/portal/apartment/rental/rentalDetail', { params })
}
// 入住申请列表
const rentalList = params => {
  return request.post('/portal/apartment/rental/rentalList', params)
}
// 人员入住房间
const stayIn = params => {
  return request.post('/portal/apartment/rental/rentalUser/stayIn', params)
}
// 人员迁出房间
const stayOut = params => {
  return request.post('/portal/apartment/rental/rentalUser/stayOut', params)
}
// 变更紧急联系人
const updateContactListOrAuthorizers = params => {
  return request.post(
    '/portal/apartment/rental/updateContactListOrAuthorizers',
    params
  )
}
// 修改租赁信息
const updateRental = params => {
  return request.post('/portal/apartment/rental/updateRental', params)
}
// 公寓账单
const getBillList = params => {
  return request.post('/portal/apartment/bill/list', params)
}

// 公寓账单导出
const exportBillList = params => {
  return request.post('/portal/apartment/bill/list/exportExcel', params, {
    responseType: 'blob'
  })
}
// 房间详情 - 账单信息 - 分组查询账单列表
const getBillGroupList = params => {
  return request.post('/portal/apartment/bill/groupList', params)
}
// 房间详情 - 账单信息
const getBillDetailList = params => {
  return request.get(`/portal/apartment/bill/billDetail/${params}`)
}
const contractInfo = params => {
  return request.get('/portal/apartment/rental/rooms/detail/contractInfo', {
    params
  })
}

// 房间管理列表
const getRoomList = params => {
  return request.post('/portal/apartment/rental/page/room/list', params)
}

// 变更记录 列表
const getRerhangeList = params => {
  return request.post('/portal/apartment/rerhange/page/list', params)
}
// 变更单审核
const rechangeApprove = params => {
  return request.post('/portal/apartment/rechange/approve', params)
}
// 变更单数据导出
const exportRerhangeList = params => {
  return request.post('/portal/apartment/rerhange/explortDate', params, {
    responseType: 'blob'
  })
}
// 变更详情
const getRechangDetailByIdAndType = params => {
  return request.get('/portal/apartment/rerhange/getRechangDetailByIdAndType', {
    params
  })
}

// 退园办理
const rentalCheckOut = params => {
  return request.post('/portal/apartment/rental/rentalCheckOut', params)
}

// 修改入住时间
const updateRoomUsersModel = params => {
  return request.post(
    '/portal/apartment/rental/room/updateRoomUsersModel',
    params
  )
}

// 获取人员
const selectRoomUsersByRoomId = params => {
  return request.get('/portal/apartment/rental/room/selectRoomUsersByRoomId', {
    params
  })
}

// 修改入住时间
const updateLockTime = params => {
  return request.post('/portal/apartment/rentalUser/updateLockTime', params)
}

// 获取 租户代表和 紧急联系人 详情 2.0
const getContactListOrAuthorizersPage = params => {
  return request.post(
    '/portal/apartment/rental/getContactListOrAuthorizersPage',
    params
  )
}

// 获取 入住人员信息
const usersPage = params => {
  return request.post('/portal/apartment/rental/users/page', params)
}
// 物品详情
const getDetailById = params =>
  request.get('/portal/estate/houseStructure/getDetailById', { params })

// 替换户型
const updateHouseStructure = params => {
  return request.post('/portal/room/updateHouseStructure', params)
}

// 通过合同号获取入驻人员信息
const selectRoomUsersByContractId = params => {
  return request.get(
    '/portal/apartment/rentalUser/room/selectRoomUsersByContractId',
    { params }
  )
}
const queryRoomList = params => {
  return request.post('/portal/room/queryListN', params)
}
// 获取楼栋设置中的区域
const getRegionName = params => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.get('/portal/estate/regionInfo', {params})
}
// 获取楼栋设置中的楼栋
const getBuildName = params => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/estate/buildInfo', params)
}
// 获取楼层
const getFloorList = params => {
  return request.post('/portal/estate/floorInfo', params)
}
// 获取户型
const getHouseStructure = params => {
  return request.post('/portal/estate/houseStructure/map', params)
}

// 获取流程节点信息
const getTaskNodeList = params => {
  return request.post('/ipark-admin/processadmin/getTaskNodeList', params)
}
// 获取列成详细信息
const selectAppovingDetailByPid = params => {
  return request.post('/portal/message/selectAppovingDetailByPid', params)
}
// 新增或修改指纹
const fingerprintAddOrUpdate = params => {
  return request.post('/portal/apartment/lock/fingerprint/addOrUpdate', params)
}
// 删除指纹
const fingerprintDelete = params => {
  return request.post('/portal/apartment/lock/fingerprint/delete', params)
}
// 获取驳回节点
const canRejectNodes = params => {
  return request.post('/portal/message/canRejectNodes', params)
}
const transfer = params => {
  return request.post('/portal/message/transferApp', params)
}
const submit = params => {
  return request.post('/portal/message/submitApp', params)
}
const reject = params => {
  return request.post('/portal/message/reject', params)
}
const getMessageSend = params => {
  params.noIpark = true
  return request.post(
    '/ipark-admin/rest/open/messagesend/getMessageSendById',
    params
  )
}

const addTaskComment = params => {
  return request.post('/portal/message/addTaskComment', params)
}
const saveAttachent = params => {
  return request.post('/portal/message/saveAttachent', params)
}
const deleteAttachent = params => {
  return request.post('/portal/message/deleteAttachent', params)
}
// 获取公寓推送列表
const apartmentMessageList = params => {
  return request.get('/portal/apartment/message/config/list', {params})
}

// 修改公寓推送配置
const apartmentMessageUpdate = params => {
  return request.post('/portal/apartment/message/config/update', params)
}

// 查询租户
const querySimpleCommercialFloorList = params => {
  return request.post('/portal/companyBook/querySimpleCommercialFloorList', params)
}

// 新增/修改入住办理
const rentalRentalEdit = params => {
  return request.post('/portal/apartment/rental/rentalEdit', params)
}
// 删除入住办理
const rentalDelete = params => {
  return request.post('/portal/apartment/rental/rentalDelete', params)
}

export default {
  addTaskComment,
  saveAttachent,
  deleteAttachent,
  groupByRoomId,
  getListAllGoodsName,
  groupGoodsAddBatch,
  getGoodsList,
  addGoods,
  updateGoods,
  deleteGoods,
  checkNumberAndName,
  getGoodsDetail,
  getListByRoomId,
  exportGoodsList,
  getRoomList,
  getBuildingList,
  getGoodsItem,
  getRoomInfo,
  exportRoomList,
  getRoomBillList,
  getRentalList,
  exportRentalList,
  getContactListOrAuthorizers,
  rentalAdd,
  rentalDetail,
  rentalList,
  stayIn,
  stayOut,
  updateContactListOrAuthorizers,
  updateRental,
  approve,
  getBillList,
  exportBillList,
  getBillGroupList,
  getBillDetailList,
  contractInfo,
  fingerprintAddOrUpdate,
  fingerprintDelete,
  getRerhangeList,
  rechangeApprove,
  exportRerhangeList,
  getRechangDetailByIdAndType,
  rentalCheckOut,
  updateRoomUsersModel,
  selectRoomUsersByRoomId,
  updateLockTime,
  getGoodsList1,
  addGoods1,
  updateGoods1,
  deleteGoods1,
  getContactListOrAuthorizersPage,
  usersPage,
  getDetailById,
  updateHouseStructure,
  selectRoomUsersByContractId,
  queryRoomList,
  getRegionName,
  getBuildName,
  getFloorList,
  getHouseStructure,
  getTaskNodeList,
  selectAppovingDetailByPid,
  canRejectNodes,
  transfer,
  submit,
  reject,
  getMessageSend,
  lockChangeMac,
  lockVerifyMac,
  apartmentMessageList,
  apartmentMessageUpdate,
  querySimpleCommercialFloorList,
  rentalRentalEdit,
  rentalDelete
}



// WEBPACK FOOTER //
// ./src/area-apartment/api/apartmentService.js